var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-bottom-sheet', {
    attrs: {
      "value": _vm.showsRoom,
      "persistent": "",
      "fullscreen": ""
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column fill-height ma-0",
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_vm._v(" 비대면면접 / " + _vm._s(_vm.interview.title || "") + " ")]), _c('v-card-text', {
    staticClass: "pb-0",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    staticClass: "fill-height pa-8",
    attrs: {
      "color": "black",
      "flat": ""
    }
  }, [_c('room-videos')], 1)], 1), _c('v-col', {
    staticClass: "d-flex flex-column",
    attrs: {
      "cols": "3"
    }
  }, [_c('room-self'), _c('room-participants', {
    staticClass: "mt-8",
    staticStyle: {
      "flex-grow": "1"
    }
  }), _c('room-share'), _c('room-close')], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-24"
  }, [_c('room-actions')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }